interface GetProductPositionArgs {
  index: number;
  bestsellersLength: number;
  previousLength?: number;
}

/**
 * Returns the global position of a product in a multi-section grid (bestsellers + regular + more).
 * Used as the `position` prop for analytics tracking so impression and click ranks stay consistent.
 */
export const getProductPosition = ({
  index,
  bestsellersLength,
  previousLength = 0,
}: GetProductPositionArgs) => bestsellersLength + previousLength + index;
